export function stripPunctuation(text: string): string {
  return text.replace(/[^\w\s]|_/g, "").replace(/\s+/g, " ");
}
